import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import products from "../components/allProductsData";
import "../assets/css/AllProducts.css";
import BredcrumpImage from "../assets/images/hair-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const HairCareProductsPage = () => {
  const navigate = useNavigate();

  const hairCareProducts = products.filter((item) => item.category === "Hair Care");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 6;
  const totalPages = Math.ceil(hairCareProducts.length / itemsPerPage);

  const paginatedData = hairCareProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <BreadcrumbSection
        title="Hair Care Solutions"
        breadcrumbItems={[{ label: "Home", to: "/" }]}
        backgroundImage={BredcrumpImage}
      />

      <div className="allproducts-container">
        <h1 className="page-title">Hair Care Products</h1>

        <div className="allproducts-grid">
          {paginatedData.map((product) => (
            <div key={product.id} className="allproducts-card">
              <div className="allproducts-image-wrapper">
                <img src={product.image} alt={product.name} className="allproducts-image" />
                <img src={product.logo} alt="brand" className="allproducts-logo" />
                <div className="allproducts-content">
                  <h5>{product.name}</h5>
                  <button className="view-button" onClick={() => navigate(product.link)}>
                    View Product
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
            Prev
          </button>
          <span>
            {currentPage} / {totalPages}
          </span>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default HairCareProductsPage;
